// JsFromRoutes CacheKey 51be9f80a6da13de3a851d19ac4a0038
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/add-friends/:token'),
  create: /* #__PURE__ */ definePathHelper('post', '/add-friends/:token/contacts'),
}
